module.exports = __webpack_public_path__ + "static/logo-fe721a03d4b7a3b52c17b7c5c5266e00.png";